import { Colors, TextVariants } from '@lichtblick/theme';

import { AvatarRoot, Fallback, Image } from './Avatar.styles';

import { Text } from '../Text';

type AvatarProps = {
  fallback?: string;
  image?: string;
  isSmall?: boolean;
};

export const Avatar = ({ fallback, image, isSmall }: AvatarProps) => (
  <AvatarRoot $isSmall={!!isSmall}>
    <Image alt={fallback} src={image} />
    <Fallback delayMs={500}>
      <Text $variant={TextVariants.header.s} color={Colors.white}>
        {fallback}
      </Text>
    </Fallback>
  </AvatarRoot>
);
